import { render, staticRenderFns } from "./RegisterUi.vue?vue&type=template&id=4522bcec&scoped=true&"
import script from "./RegisterUi.vue?vue&type=script&lang=ts&"
export * from "./RegisterUi.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterUi.vue?vue&type=style&index=0&id=4522bcec&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4522bcec",
  null
  
)

export default component.exports